// Touch input mailbox.
//
// The walker lives inside the r3f canvas and can't render DOM, and the thumb
// stick has to be DOM (it sits over the canvas and needs to be drawn at 60fps
// without re-rendering the scene). So TouchControls writes here and
// FirstPersonController reads it each frame. A plain mutable object, not a
// store: these values change every frame while a thumb is down, and pushing
// that through zustand would re-render the world on every touchmove.
//
// move: analog stick, -1..1. x = turn (right positive), y = forward positive.
// look: pixel deltas since the last frame read, drained by the reader.
export const touchInput = {
  moveX: 0,
  moveY: 0,
  lookDX: 0,
  lookDY: 0,
}

// Read-and-clear the look delta. Look is expressed as "pixels moved since you
// last asked", so it must be drained or a flick would keep turning forever.
export function drainLook() {
  const dx = touchInput.lookDX
  const dy = touchInput.lookDY
  touchInput.lookDX = 0
  touchInput.lookDY = 0
  return [dx, dy]
}

export function resetTouchInput() {
  touchInput.moveX = 0
  touchInput.moveY = 0
  touchInput.lookDX = 0
  touchInput.lookDY = 0
}
